import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractDateFromTacho'
})
export class ExtractDateFromTachoPipe implements PipeTransform {

  transform(value: string, arg: any) : string {
    
    let daysToExtract: number = 28; //plik karty
    if(arg==0)
      daysToExtract=60; //plik tacho

    let temporaryDate = new Date(value.slice(0,value.indexOf(".")).split("-").join("/"));
    temporaryDate.setDate(temporaryDate.getDate()-daysToExtract);
    return temporaryDate.toISOString().substring(0, 10);
  }

}
